/**
 * DirectionsButton — Deep link to Google Maps or Apple Maps
 */
import { Navigation } from 'lucide-react';

const DirectionsButton = ({ name, address, lat, lng, className = '' }) => {
  const handleDirections = () => {
    const query = encodeURIComponent(`${name} ${address || ''}`);
    // Detect iOS for Apple Maps, else Google Maps
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      window.open(`maps://maps.apple.com/?daddr=${lat ? `${lat},${lng}` : query}&dirflg=d`, '_blank');
    } else {
      const dest = lat ? `${lat},${lng}` : query;
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${dest}`, '_blank');
    }
  };

  return (
    <button onClick={handleDirections}
      className={`inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#FF6B35] transition-colors ${className}`}
      data-testid="directions-btn">
      <Navigation className="w-4 h-4" />
      Directions
    </button>
  );
};

export default DirectionsButton;
